import { memo, useEffect } from 'react'
import { useFiltersDialog } from '../../providers/FiltersDialogProvider'

const FiltersPage = () => {
  const { openFiltersDialog, closeFiltersDialog } = useFiltersDialog()
  useEffect(() => {
    openFiltersDialog()
    return () => {
      closeFiltersDialog()
    }
  })
  return null
}

export default memo(FiltersPage)
